import { apiSlice } from './apiSlice';
import { fetchWorldCitiesQueryFn } from './fetchWorldCities';

export const worldCitiesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWorldCities: builder.query({
      queryFn: fetchWorldCitiesQueryFn,
      keepUnusedDataFor: 60 * 60,
    }),
  }),
  overrideExisting: true,
});

export const { useGetWorldCitiesQuery } = worldCitiesApiSlice;
